import { createFileRoute } from '@tanstack/react-router';
import { sourceRunsQuery } from '@/features/runs/api';
import { sourcesQuery } from '@/features/sources/api';
import { SourcePage } from '@/features/sources/pages/SourcePage';
import { sourceSearchSchema } from '@/features/sources/search';

export const Route = createFileRoute('/_authed/ops/sources/$sourceId')({
  staticData: { help: 'source' },
  validateSearch: sourceSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context: { queryClient }, params, deps }) => {
    void queryClient.prefetchQuery(sourcesQuery());
    void queryClient.prefetchQuery(sourceRunsQuery(params.sourceId));
    void queryClient.prefetchQuery(sourceRunsQuery(params.sourceId, deps.page));
  },
  component: SourcePage,
});
